import { useContext, useEffect } from 'react';

import { PageTitleContext } from '@shared/context/PageTitleContextWrapper';

import { useExtendedRouter } from '../useExtendedRouter';

interface UseDocumentTitleParams {
  finalTitle?: string;
  skip?: boolean;
}

const useDocumentTitle = ({ finalTitle, skip }: UseDocumentTitleParams) => {
  const { displayTitle } = useExtendedRouter();
  const { setPageTitle } = useContext(PageTitleContext)!;

  useEffect(() => {
    if (!skip && displayTitle) {
      document.title = displayTitle;
    }
  }, [skip, displayTitle]);

  useEffect(() => {
    if (!skip && finalTitle) {
      document.title = finalTitle;
      setPageTitle(finalTitle);
    }

    return () => {
      setPageTitle(undefined);
    };
  }, [finalTitle, skip, setPageTitle, displayTitle]);
};

export default useDocumentTitle;
